import React from 'react'
import { Container, Grid, Box, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { TrackEvent } from '../../GA'

export const Footer: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const { REACT_APP_RULES_URL: RULES, REACT_APP_AGREEMENTS_URL: AGREEMENTS, REACT_APP_EMAIL: EMAIL } = process.env

  const mdDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))

  const onClickRules = () => {
    TrackEvent({ eventCategory: 'InteractionDoc', eventAction: 'rules' })
  }

  return (
    <Box className={classes.footer}>
      <Container className={classes.container}>
        <Grid
          container
          direction="row"
          justifyContent={mdDown ? 'center' : 'space-between'}
          alignItems="center"
          spacing={0}
          style={{ height: '100%' }}
        >
          <Grid item xs={12} md="auto">
            <Grid container justifyContent="center" alignItems="center">
              <Grid item>
                <a
                  href={RULES}
                  className={classes.rules}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClickRules}
                >
                  Pro правила
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md="auto">
            <Grid container justifyContent="center" alignItems="center">
              <Grid item>
                <Box className={classes.boxEmail}>
                  Пишите нам на&nbsp;
                  <a href={`mailto:${EMAIL}`} className={classes.email} target="_blank" rel="noopener noreferrer">
                    {EMAIL}
                  </a>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  footer: {
    fontSize: 16,
    fontWeight: 400,
    height: 100,
    backgroundColor: palette.primary.dark,
    color: '#6C6C6C!important',
    [down('md')]: {
      height: 130,
    },
    [down('sm')]: {
      height: 120,
      fontSize: 14,
    },
  },
  container: {
    maxWidth: '1300px!important',
    height: '100%',
  },
  rules: {
    fontWeight: 600,
    transition: '.3s',
    textTransform: 'uppercase',
    color: palette.primary.contrastText,
    '-webkit-tap-highlight-color': 'transparent',
    textDecorationColor: 'rgb(255, 255, 255, 0.6)!important',
    '&:hover': {
      textDecorationColor: `${palette.primary.contrastText}!important`,
    },
    [down('md')]: {
      position: 'relative',
      top: 7,
    },
  },
  boxEmail: {
    fontWeight: 500,
    [down('md')]: {
      position: 'relative',
      bottom: 12,
    },
  },
  email: {
    '-webkit-tap-highlight-color': 'transparent',
    textDecoration: 'none',
    transition: '.3s',
    color: '#6C6C6C!important',
    '&:hover': {
      textDecoration: 'none',
      color: `${palette.primary.contrastText}!important`,
    },
  },
}))
